import DocumentPreview from "./DocumentPreview";
import document1 from "../../../assests/HPE/enterpriseone/ent-a/webp/zip-documents-1.webp";
import document2 from "../../../assests/HPE/enterpriseone/ent-a/webp/zip-documents-2.webp";
import document3 from "../../../assests/HPE/enterpriseone/ent-a/webp/zip-documents-3.webp";
import downloadIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/download.svg";


const DocumentForm = () => {
  const docs = [
    { img: document2, title: "GigaOm Radar", pages: "52 pages · PDF" },
    {
      img: document3,
      title: "AstraZeneca Customer Story",
      pages: "4 pages · PDF",
    },
    { img: document1, title: "IDC Spotlight", pages: "8 pages · PDF" },
  ];

  return (
    <div className="w-full bg-navy-blue-01 py-12 px-4">
      <div className="max-w-[1128px] mx-auto flex flex-col gap-10 md:gap-16">
        {/* Heading */}
        <div className="flex flex-col gap-3 max-w-[600px]">
          <p className="text-grey-02">Your resource pack is ready</p>
          <p className="text-grey-04 text-[16px]">
            Click below to download each document. If downloads do not start
            automatically, check your email.
          </p>
        </div>

        {/* Main Section */}
        <div className="flex flex-col md:flex-row gap-10 md:gap-24 w-full">
          {/* LEFT */}
          <div className="flex flex-col items-start gap-3 md:gap-4 self-stretch">
            <DocumentPreview />
            <button className="w-full p-3 rounded-lg bg-blue text-white">
              Download
            </button>
          </div>

          {/* RIGHT CARD */}
          <div className="w-full md:w-[648px] bg-navy-blue-02 rounded-[12px] p-4 md:p-6 flex flex-col gap-6">
            <p className="text-grey-01 text-[16px]">
              You can also download files individually
            </p>

            {/* LIST */}
            <div className="flex flex-col">
              {docs.map((doc, i) => (
                <div key={i}>
                  {/* ITEM */}
                  <div className="flex items-center justify-between gap-4 py-4">
                    {/* LEFT CONTENT */}
                    <div className="flex items-center gap-3">
                      <div className="w-[42px] h-[42px] flex items-center justify-center rounded-[4px] bg-[#5B5D7C] pt-1 px-1 pb-0">
                        <img
                          src={doc.img}
                          className="w-full h-full object-cover rounded-sm"
                        />
                      </div>

                      <div>
                        <p className="text-grey-01">{doc.title}</p>
                        <p className="text-grey-03 text-sm">{doc.pages}</p>
                      </div>
                    </div>

                    {/* DOWNLOAD ICON */}
                    <img
                      src={downloadIcon}
                      alt=""
                      className="w-5 h-5 cursor-pointer"
                    />
                  </div>

                  {/* DIVIDER (except last) */}
                  {i !== docs.length - 1 && (
                    <div className="border-t border-grey-04/30"></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DocumentForm;
